import { ContentProvider } from "@stubhub/broadway-state";
import { CONTENT_KEY_ENSEMBLE_DISCOVERY, EventGridListItemCalendar } from "@stubhub/ensemble-discovery";
import { mlbPlayoffCalendarClasses, mlbPlayoffUnknownCalendarClasses } from "./MlbPlayoffs.styles";

export const MlbPlayoffCalendar = ({
  dateConfirmed,
  tbd,
}: {
  dateConfirmed: boolean | undefined;
  tbd: string | undefined;
}) => (
  <ContentProvider value={tbd ? { [CONTENT_KEY_ENSEMBLE_DISCOVERY]: { tba: tbd } } : {}}>
    <EventGridListItemCalendar classes={dateConfirmed ? mlbPlayoffCalendarClasses : mlbPlayoffUnknownCalendarClasses} />
  </ContentProvider>
);
